import { render, staticRenderFns } from "./u-btn-flat-rounded.vue?vue&type=template&id=db09b9cc&scoped=true&"
import script from "./u-btn-flat-rounded.vue?vue&type=script&lang=js&"
export * from "./u-btn-flat-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db09b9cc",
  null
  
)

export default component.exports